module.exports = {"360830100":"禾川镇","360830101":"石桥镇","360830102":"龙源口镇","360830103":"浬田镇","360830104":"龙门镇","360830105":"沙市镇","360830106":"文竹镇","360830107":"埠前镇","360830108":"怀忠镇","360830109":"高桥楼镇","360830200":"坳南乡","360830201":"曲白乡","360830202":"才丰乡","360830203":"烟阁乡","360830204":"在中乡","360830205":"三湾乡","360830206":"台岭乡","360830207":"龙田乡","360830208":"高溪乡","360830209":"莲洲乡","360830210":"高市乡","360830211":"象形乡","360830212":"芦溪乡","360830400":"永新县工业园区","360830501":"永新县综合垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360830.json
// module id = 1215
// module chunks = 0